import React, { Reducer, useEffect, useReducer, useState } from 'react'
import styled from 'styled-components'
import i18n from 'live/services/i18n'
import globalConfirmation from 'live/services/global-confirmation'
import { ModalScheduling } from './ModalScheduling'
import Report, { MailSettingsInstance } from '../../../common/types/api/report'
import { getScheduleType, getScheduleTypeName } from './helper/helper'
import { SCHEDULE_HEADER, store } from './helper/Const'
import { ActionTypesReducer, ScheduleActionComponent, SheduleActions, sheduleReducer } from './helper/ScheduleContext'

interface RecipientGroupsProps {
    formObject: Report
    onChange: (formObject: MailSettingsInstance[]) => void
}

export const Scheduling = ({ formObject, onChange }: RecipientGroupsProps): JSX.Element => {
    const [editingModal, setEditingModal] = useState<{ showing: boolean; i: number }>({
        showing: false,
        i: 0
    })
    const [newModal, setNewModal] = useState<boolean>(false)
    const report = { ...formObject }

    const [actionsComponents, dispatch] = useReducer<Reducer<ScheduleActionComponent<any>[], ActionTypesReducer>>(
        sheduleReducer,
        []
    )

    useEffect(() => {
        if (!store.isReady) {
            store.init({
                dispatch: params => dispatch(params)
            })
        } else {
            store.bufferEvents.map(eventStore => dispatch(eventStore))
        }
    }, [store])

    return (
        <StyledScheduling className={'rmScheduling'} tabIndex={0}>
            <button
                className={'rmScheduling--btnAddSchedulingJob'}
                onClick={() => {
                    setNewModal(true)
                }}
            >
                <span className={'rmScheduling--btnAddSchedulingJob__pĺus'}>+</span>
                {i18n('Add new schedule')}
            </button>
            {newModal && (
                <ModalScheduling
                    showingModal={newModal}
                    allRecipients={report.mailSettings?.recipients ?? []}
                    isNew={newModal}
                    onSave={newSchedulingInstance => {
                        const newSchedulingJobs = [...(report.mailSettings?.mailSettingsInstances ?? [])]
                        if (!newSchedulingJobs.includes(newSchedulingInstance)) {
                            newSchedulingJobs.push(newSchedulingInstance)
                        }
                        onChange([...newSchedulingJobs])
                    }}
                    onClose={hideModal => {
                        setNewModal(hideModal)
                    }}
                />
            )}
            <div className={'rmScheduling--scheduleList__header'}>
                {SCHEDULE_HEADER.map(header => {
                    return <div className={'rmScheduling--scheduleList__header--section'}>{i18n(header.label)}</div>
                })}
            </div>
            <NoSchedule open={!(report.mailSettings?.mailSettingsInstances.length < 1)}>
                <i className="far fa-folder-open" />
                <span className="noPreview">{i18n('No schedules have been added')}.</span>
            </NoSchedule>
            {report.mailSettings?.mailSettingsInstances?.map((mailSettingsInstance, index) => {
                return (
                    <div className={'rmScheduling--scheduleList__element'} key={index}>
                        {SCHEDULE_HEADER.map(header => {
                            return (
                                <div
                                    className={'rmScheduling--scheduleList__element--section'}
                                    onClick={ev => {
                                        if (header.label != 'Status') setEditingModal({ showing: true, i: index })
                                    }}
                                >
                                    {header.getValue(mailSettingsInstance, newSettings => {
                                        const newSchedulingJobs = [...report.mailSettings?.mailSettingsInstances]
                                        newSchedulingJobs[index] = { ...newSettings }
                                        onChange([...newSchedulingJobs])
                                    })}
                                </div>
                            )
                        })}
                        <div className={'rmScheduling--scheduleList__element--section--actions'} key={index}>
                            <SheduleActions
                                schedule={mailSettingsInstance}
                                scheduleType={getScheduleType(mailSettingsInstance)}
                                actionsComponents={actionsComponents}
                                dispatch={dispatch}
                            />
                            <span
                                className={
                                    'rmScheduling--scheduleList__element--section--actions--actionEditIcon actions-icon far fa-edit'
                                }
                                onClick={() => {
                                    setEditingModal({ showing: true, i: index })
                                }}
                            />
                            <ModalScheduling
                                showingModal={editingModal.i === index && editingModal.showing}
                                onSave={newSchedulingJob => {
                                    const newSchedulingJobs = [...report.mailSettings?.mailSettingsInstances]
                                    newSchedulingJobs[index] = { ...newSchedulingJob }
                                    onChange([...newSchedulingJobs])
                                }}
                                onClose={hideModal => {
                                    setEditingModal({ ...editingModal, showing: hideModal })
                                }}
                                mailSettingsInstance={mailSettingsInstance}
                                allRecipients={report.mailSettings?.recipients ?? []}
                            />

                            <span
                                className={
                                    'rmScheduling--scheduleList__element--section--actions--actionTrashIcon actions-icon far fa-trash-alt'
                                }
                                onClick={() => {
                                    globalConfirmation.confirm(
                                        i18n(
                                            `Are you sure you want to delete the scheduling job: ${mailSettingsInstance.name} ?`
                                        ),
                                        () => {
                                            report.mailSettings?.mailSettingsInstances.splice(index, 1)
                                            onChange([...report.mailSettings?.mailSettingsInstances])
                                        }
                                    )
                                }}
                            />
                        </div>
                    </div>
                )
            })}
        </StyledScheduling>
    )
}

const NoSchedule = styled.div<{ open: boolean }>`
    display: ${({ open }) => (!open ? 'flex' : 'none')};
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 80px;
    padding-top: 56px;

    /* background: ${({ theme }) => theme['gray-100']}; */

    .noPreview {
        padding-top: 8px;
        color: ${({ theme }) => theme['gray-700']};
        text-align: center;
        font-size: 13px;
        font-style: ${({ theme }) => theme['font-semibold']};
        font-weight: 600;
        line-height: normal;
    }
    .noPreviewText {
        width: 210px;
        color: ${({ theme }) => theme['gray-600']};
        text-align: center;
        font-style: ${({ theme }) => theme['font-regular']};
        font-size: 13px;
        font-style: italic;
        font-weight: 400;
        line-height: normal;
    }

    i {
        font-size: 32px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        color: ${({ theme }) => theme['gray-500']};
    }
`

const StyledScheduling = styled.div`
    .rmScheduling {
        display: flex;
        flex-direction: column;
        width: 100%;

        &--btnAddSchedulingJob {
            width: 166px;
            height: 32px;
            color: white;
            font-size: 14px;
            line-height: 16px;
            background: ${({ theme }) => theme['blue-500']};
            border: 0;
            border-radius: 3px;
            margin-bottom: 15px;
            margin-top: 20px;
            transition: 0.3s;

            &:active {
                background: ${({ theme }) => theme['blue-700']};
            }

            &__pĺus {
                margin-right: 5px;
                font-size: 15px;
            }
        }

        &--scheduleList {
            display: grid;
            grid-template-columns: 1fr;
            margin-left: 10%;
            margin-right: 10%;

            &__header {
                display: grid;
                /* grid-template-columns: 30% 20% 20% 20% 1fr; */
                grid-template-columns: 30% 20% 20% 20% 1fr;
                /* border: 1px solid ${({ theme }) => theme['gray-300']}; */
                background: ${({ theme }) => theme['gray-100']};
                border-top-right-radius: 3px;
                border-top-left-radius: 3px;
                border-bottom: 0px;
                width: 100%;
                height: 32px;
                &--section {
                    display: flex;
                    flex-direction: row;
                    padding-left: 30px;
                    align-items: center;
                    font-style: normal;
                    font-weight: 600;
                    font-size: 12px;
                    color: ${({ theme }) => theme['gray-700']};
                }
                padding: 2px 0 0;
            }
            &__element {
                display: grid;
                grid-template-columns: 30% 20% 20% 20% 1fr;
                background-color: ${({ theme }) => theme['gray-0']};
                border-top: 1px solid ${({ theme }) => theme['gray-500']};
                padding-top: 5px;
                padding-bottom: 5px;
                width: 100%;
                min-height: 48px;
                height: auto;
                font-size: 12px;
                cursor: pointer;
                span.actions-icon {
                    display: flex;
                }
                transition-duration: 0.2s;

                &--section {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    padding-left: 30px;
                    word-wrap: break-word;

                    &--actions {
                        display: flex;
                        align-items: center;
                        justify-content: end;
                        padding-right: 30px;

                        &--actionEditIcon {
                            font-size: 12px;
                            margin-right: 8px;
                            cursor: pointer;
                            color: ${({ theme }) => theme['blue-500']};
                            &:hover {
                                color: ${({ theme }) => theme['blue-400']};
                            }
                        }
                        &--actionTrashIcon {
                            font-size: 12px;
                            cursor: pointer;
                            color: ${({ theme }) => theme['red-500']};
                            &:hover {
                                color: ${({ theme }) => theme['red-300']};
                            }
                        }
                    }

                    &--executionAt {
                        display: flex;
                        flex-direction: column;
                    }

                    &--italic-text {
                        padding-left: 30px;
                        font-style: italic;
                        color: red;
                    }
                }
            }
        }
    }
`
